export var sliceLongText = function (text, maxLength) {
    if (text === null || text === undefined)
        return '';
    return text.length > maxLength ? "".concat(text.slice(0, maxLength - 3), "...") : text;
};
export var generateOrderOrigin = function (order) {
    if ((order === null || order === void 0 ? void 0 : order.orderOrigin) === undefined &&
        (order === null || order === void 0 ? void 0 : order.detailsSource) === undefined)
        return '---';
    if ((order === null || order === void 0 ? void 0 : order.orderOrigin) === 'online' ||
        (order === null || order === void 0 ? void 0 : order.detailsSource) === 'online') {
        return 'Online';
    }
    if ((order === null || order === void 0 ? void 0 : order.orderOrigin) === undefined &&
        (order === null || order === void 0 ? void 0 : order.detailsSource) === 'InStore')
        return 'In Store';
    return order === null || order === void 0 ? void 0 : order.orderOrigin;
};
var getOrderType = function (orderNumber) {
    if (orderNumber && (orderNumber[0] === 'W' || orderNumber[0] === 'C')) {
        return 'ONLINE';
    }
    return 'INSTORE';
};
export var generateOrderDetailsRequest = function (_a, customerType, svocID, timezone, requestOriginatedFrom) {
    var transactionType = _a.transactionType, transactionId = _a.transactionId, registerNumber = _a.registerNumber, salesDate = _a.salesDate, storeNumber = _a.storeNumber, orderNumber = _a.orderNumber, orderNumbers = _a.orderNumbers;
    if (requestOriginatedFrom === void 0) { requestOriginatedFrom = 'purchaseHistory'; }
    var filteredOrderNumber = orderNumber !== null && orderNumber !== void 0 ? orderNumber : orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0];
    var orderType = getOrderType(filteredOrderNumber);
    if (customerType === 'b2b' && orderType === 'ONLINE') {
        if (transactionType === 'R') {
            return {
                orderDetailsRequest: {
                    searchType: 'online',
                    registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                    salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                    storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                    transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                    transactionType: transactionType !== null && transactionType !== void 0 ? transactionType : '',
                    orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                    customerAccountId: svocID,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: requestOriginatedFrom,
                    timezone: timezone,
                },
            };
        }
        return {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                requestOriginatedFrom: requestOriginatedFrom,
                timezone: timezone,
            },
        };
    }
    if (customerType === 'b2b' && orderType === 'INSTORE') {
        return {
            orderDetailsRequest: {
                searchType: 'instore',
                registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
                requestOriginatedFrom: requestOriginatedFrom,
                timezone: timezone,
            },
        };
    }
    return {
        orderDetailsRequest: {
            searchType: orderType === null || orderType === void 0 ? void 0 : orderType.toLowerCase(),
            orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
            requestOriginatedFrom: requestOriginatedFrom,
            timezone: timezone,
        },
    };
};
